import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import axios from "axios";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import IndustriesSection from "./components/IndustriesSection";
import AboutSection from "./components/AboutSection";
import TeamSection from "./components/TeamSection";
import AboutUs from "./pages/Aboutus";
import ContactUs from "./pages/ContactUs";
import AuditAssurance from "./pages/AuditAssurance";
import Career from "./pages/Career";
import TaxationCompliance from "./pages/TaxationCompliance";
import CorporateCompliance from "./pages/CorporateCompliance";
import BusinessAdvisory from "./pages/BusinessAdvisory";
import BankingFinance from "./pages/BankingFinance";
import CapitalMarketSEBI from "./pages/CapitalMarketSEBI";
import InternationalNRI from "./pages/InternationalNRI";
import OutsourcingOther from "./pages/OutsourcingOther";
import Achievements from "./pages/Achievements";
import DepositoryParticipantAudit from "./pages/DepositoryParticipantAudit";
import SystemAuditCapitalMarket from "./pages/SystemAuditCapitalMarket";
import ExchangeSEBICompliances from "./pages/ExchangeSEBICompliances";
import IPOLisitingSupport from "./pages/IPOLisitingSupport";
import DirectTax from "./pages/DirectTax";
import IndirectTax from "./pages/IndirectTax";
import EngagementProcess from "./components/EngagementProcess";
import ComplianceOverview from "./components/ComplianceOverview";
import Admindashbord from "./admin/Admindashbord";
import AdminUpload from "./admin/AdminUpload";
import AdminLogin from "./admin/AdminLogin";
import LocState from "./components/context/LocState";
import OurSpecialization from "./components/OurSpecialization";
import BlogList from "./admin/blog/BlogList";
import CreateBlog from "./admin/blog/CreateBlog";
import EditBlog from "./admin/blog/EditBlog";
import DownloadList from "./admin/download/DownloadList";
import CreateDownload from "./admin/download/CreateDownload";
import EditDownload from "./admin/download/EditDownload";
import Forgotpassword from "./admin/Forgotpassword";
import ViewBlog from "./admin/blog/ViewBlog";
import PdfDownloadList from "./admin/download/PdfDownloadList";
import EditJob from "./admin/job/EditJob";
import CreateJob from "./admin/job/CreateJob";
import JobList from "./admin/job/JobList";
import JobApplication from "./admin/job/JobApplication";
import ApplicaitonView from "./admin/job/ApplicatoinView";
import CandidateView from "./admin/candidate/CandidateView";
import CandidateList from "./admin/candidate/CandidateList";
import CalendarList from "./admin/calendar/CalendarList";
import CalendarCreate from "./admin/calendar/CalendarCreate";
import CalendarEdit from "./admin/calendar/CalendarEdit";

axios.defaults.withCredentials = true;
const PrivateRoute = ({ element }) => {
  const [authStatus, setAuthStatus] = useState(false); // Tracks authentication status
  const [loading, setLoading] = useState(true); // Tracks loading state

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/user/session`)
      .then((res) => {
        if (res.data.Status === "Success") {
          setAuthStatus(true); // User is authenticated
        } else {
          setAuthStatus(false); // Authentication failed
        }
      })
      .catch((err) => {
        console.error(err);
        setAuthStatus(false);
      })
      .finally(() => {
        setLoading(false); // Stop loading
      });
  }, []);

  if (loading) {
    return (
      <div className="mainloader">
        <div className="loader"></div>
      </div>
    ); // Show a loading spinner or placeholder
  }
  if (!authStatus) {
    return <Navigate to="/login" />;
  }
  return element;
};

function App() {
  return (
    <Router>
      <LocState>
        <Routes>
          {/* Home Page */}
          <Route
            path="/"
            element={
              <>
                <Header />
                <HeroSection />
                <ServicesSection />
                <IndustriesSection />
                <AboutSection />
                <OurSpecialization />
                {/* <MissionVisionSection /> */}
                {/* <EngagementProcess /> */}
                <ComplianceOverview />
                <TeamSection />
                <Footer />
              </>
            }
          />

          {/* About Page */}
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/career" element={<Career />} />
          <Route path="/audit-assurance" element={<AuditAssurance />} />
          <Route path="/taxation-compliance" element={<TaxationCompliance />} />
          <Route path="/direct-tax" element={<DirectTax />} />
          <Route path="/indirect-tax" element={<IndirectTax />} />
          <Route
            path="/corporate-compliance"
            element={<CorporateCompliance />}
          />
          <Route path="/business-advisory" element={<BusinessAdvisory />} />
          <Route path="/banking-finance" element={<BankingFinance />} />
          <Route path="/capital-market-sebi" element={<CapitalMarketSEBI />} />
          <Route path="/international-nri" element={<InternationalNRI />} />
          <Route path="/outsourcing-other" element={<OutsourcingOther />} />
          <Route path="/knowledgecenter" element={<Achievements />} />
          <Route
            path="/depository-participant-audit"
            element={<DepositoryParticipantAudit />}
          />
          <Route
            path="/system-audit-capital-market"
            element={<SystemAuditCapitalMarket />}
          />
          <Route
            path="/exchange-sebi-compliances"
            element={<ExchangeSEBICompliances />}
          />
          <Route path="/ipo-listing-support" element={<IPOLisitingSupport />} />
          <Route path="/engagementProcess" element={<EngagementProcess />} />
          <Route path="/complianceoverview" element={<ComplianceOverview />} />

          {/* <Route path="/adminnavbar" element={<Adminnavbar />} /> */}

          <Route path='/admindashbord' element={<PrivateRoute element={<Admindashbord />} />} />
          <Route path='/adminupload' element={<PrivateRoute element={<AdminUpload />} />} />
          <Route path="/login" element={<AdminLogin />} />
          <Route path="/forgot-password" element={<Forgotpassword />} />


          {/*     Blog      */}
          <Route path='/knowledge-center-list' element={<PrivateRoute element={<BlogList />} />} />
          <Route path='/create-knowledge-center' element={<PrivateRoute element={<CreateBlog />} />} />
          <Route path='/update-knowledge-center/:id' element={<PrivateRoute element={<EditBlog />} />} />
          <Route path="/view-knowledge-center/:id" element={<ViewBlog />} />




          {/* Download */}
          <Route path='/ppt-tool-list' element={<PrivateRoute element={<DownloadList />} />} />
          <Route path='/create-ppt-tool' element={<PrivateRoute element={<CreateDownload />} />} />
          <Route path='/update-ppt-tool/:id' element={<PrivateRoute element={<EditDownload />} />} />
          <Route path="/pdf-download-list" element={<PdfDownloadList />} />

          {/* Job */}
          <Route path='/job-list' element={<PrivateRoute element={<JobList />} />} />
          <Route path='/create-job' element={<PrivateRoute element={<CreateJob />} />} />
          <Route path='/update-job/:id' element={<PrivateRoute element={<EditJob />} />} />

          {/* Job Application */}
          <Route path='/job-application-list' element={<PrivateRoute element={<JobApplication />} />} />
          <Route path='/job-application-view/:id' element={<PrivateRoute element={<ApplicaitonView />} />} />

          {/* Candidate Inquiry */}
          <Route path='/candidate-inquiry-list' element={<PrivateRoute element={<CandidateList />} />} />
          <Route path='/candidate-inquiry-view/:id' element={<PrivateRoute element={<CandidateView />} />} />
          
          {/* Calendar */}
          <Route path='/calendar-list' element={<PrivateRoute element={<CalendarList />} />} />
          <Route path='/create-calendar' element={<PrivateRoute element={<CalendarCreate />} />} />
          <Route path='/update-calendar/:id' element={<PrivateRoute element={<CalendarEdit />} />} />

        </Routes>
      </LocState>
    </Router>
  );
}

export default App;
